import axios from 'axios';

export async function fetchNotifications() {
  return (await axios.get('/fetch-notifications/')).data.data.map(n => ({
    ...n,
    id: n.notificationId,
  }));
}

export async function readNotifications(notificationIds) {
  return (await axios.post('/read-notifications/', {
    notifications: notificationIds,
  })).data;
}
